import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { campusEnums } from '../enums'
import { campusActions } from '../redux/actions'
import { selectCampus } from '../redux/selectors/index.ts'

function useCampus() {
  const dispatch = useDispatch()
  const campus: campusEnums.codes = useSelector(selectCampus)

  const setCampus = useCallback((campusCode: campusEnums.codes): void => {
    dispatch(campusActions.update(campusCode))
  }, [dispatch])

  const resetCampus = useCallback((): void => {
    dispatch(campusActions.update(campusEnums.codes.UNKNOWN))
  }, [dispatch])

  return { campus, resetCampus, setCampus }
}

export default useCampus
